import { navigate } from '@reach/router';
import { path } from 'commons/router/routerConfig';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { requestAuthentication, requestLogin, requestLogout } from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';
import { Auth } from 'commons/constants/KeyFlowConstants';

export default function useUser() {
  const dispatch = useDispatch();

  const onLogin = useCallback(
    (userId: string, password: string) => dispatch(requestLogin({ userId, password })),
    [dispatch],
  );

  const onLogout = useCallback(() => dispatch(requestLogout()), [dispatch]);

  // 로그인 체크
  const onAuthenticate = useCallback(
    (url: string) => {
      dispatch(requestAuthentication({ url }));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      onLogin,
      onLogout,
      onAuthenticate,
    }),
    [onLogin, onLogout, onAuthenticate],
  );
}
